import { type SupportedLocale } from '@zep-us/i18n';
import { type AxiosResponse } from 'axios';

import { AI_HTTP_CLIENT } from '@/api/ai/client';

import type { YoutubeVideoDataApiResponse } from './types';

/**
 * YouTube API utilities using AI Server
 *
 * IMPORTANT: Uses AI_HTTP_CLIENT for automatic:
 * - Authorization header (Bearer token)
 * - X-Quiz-Server-Name header
 * - snake_case ↔ camelCase conversion
 * - baseURL configuration (NEXT_PUBLIC_AI_SERVER_BASEURL)
 * - LONG_REQUEST_TIMEOUT (5 minutes)
 */
export const youtubeApi = {
  /**
   * Get YouTube video preview data
   * @param videoId - YouTube video ID (11 characters)
   * @returns Promise<YoutubeVideoData>
   * @throws Error if API call fails
   */
  getPreview: async (videoId: string): Promise<YoutubeVideoDataApiResponse> => {
    const response = await AI_HTTP_CLIENT.get<YoutubeVideoDataApiResponse>(
      `/quiz-builder/youtube/preview/${videoId}`,
    );
    return response.data;
  },

  fetchSubtitle: (
    videoId: string,
    locale: SupportedLocale,
  ): Promise<AxiosResponse> => {
    return AI_HTTP_CLIENT.post(`/quiz-builder/youtube/subtitle`, {
      video_id: videoId,
      locale,
    });
  },
};
